import React from 'react';
import type { PayoutType } from '../../types/payout';

interface TransactionTypeSelectorProps {
  selectedType: PayoutType;
  onTypeChange: (type: PayoutType) => void;
  isEditing: boolean;
}

export const TransactionTypeSelector: React.FC<TransactionTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
  isEditing,
}) => {
  const types: { type: PayoutType; label: string; description: string }[] = [
    { type: 'payout', label: 'Payout', description: 'Revenu de minage' },
    { type: 'stacking', label: 'Stacking', description: 'Revenu de stacking' },
    { type: 'achat', label: 'Achat', description: 'Achat de tokens' },
    { type: 'vente', label: 'Vente', description: 'Vente de tokens' },
    { type: 'swap', label: 'Swap', description: 'Échange crypto' },
    { type: 'transfert', label: 'Transfert', description: 'Transfert de tokens' },
  ];

  return (
    <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Type de transaction</h3>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
        {types.map(({ type, label, description }) => (
          <button
            key={type}
            type="button"
            onClick={() => onTypeChange(type)}
            disabled={isEditing}
            className={`p-4 rounded-lg border-2 transition-all ${
              selectedType === type
                ? 'border-blue-500 bg-blue-50 text-blue-900'
                : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:border-gray-400 hover:dark:border-gray-600'
            } ${isEditing ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="font-semibold text-lg">{label}</div>
            <div className="text-sm mt-1">{description}</div>
          </button>
        ))}
      </div>
      {isEditing && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-3">Le type de transaction ne peut pas être modifié</p>
      )}
    </div>
  );
};
